// extracted by mini-css-extract-plugin
module.exports = {"sectionMap":"PraxisHPG_sectionMap__nzTyY","hpgTable":"PraxisHPG_hpgTable__Yhvts"};